$(document).ready(function () {
  // 店舗メニューの動作
  let $menuBtn = $('.l-header__btn--tel');
  let $storeMenu = $('.l-header__store');
  let $body = $('body');
  $menuBtn.on('click', function () {
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      $body.css('overflow', 'hidden');
      $storeMenu.fadeIn(500).css('display', 'flex');
    } else {
      $storeMenu.fadeOut(500);
      $body.css('overflow', '');
    }
  });

  // SP版メニューの動作

  let $burgerBtn = $('.l-header__btn--burger');
  let $sideMenu = $('.l-header__side');
  let $storeMenuSp = $('.p-bottom_btns__item--tel');
  
  // サイドメニューの動作
  $burgerBtn.on('click', function () {
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      $body.css('overflow', 'hidden');
      $sideMenu.fadeIn(500).css('display', 'flex');
      if ($storeMenuSp.hasClass('open')) {
        $storeMenuSp.removeClass('open');
        $storeMenu.fadeOut(500);
      }
    } else {
      $sideMenu.fadeOut(500);
      $body.css('overflow', '');
    }
  });

  // 店舗メニューの動作
  $storeMenuSp.on('click', function () {
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      $body.css('overflow', 'hidden');
      $storeMenu.fadeIn(500).css('display', 'flex');
      if ($burgerBtn.hasClass('open')) {
        $burgerBtn.removeClass('open');
        $sideMenu.fadeOut(500);
      }
    } else {
      $storeMenu.fadeOut(500);
      $body.css('overflow', '');
    }
  });
  
  // 店舗メニューのクローズボタンの動作
  let $closeBtnSp = $('.l-header__store_close_btn');
  $closeBtnSp.on('click', function () {
    if ($storeMenuSp.hasClass('open')) {
      $storeMenuSp.removeClass('open');
      $storeMenu.fadeOut(500);
      $body.css('overflow', '');
    }
  });
});
